import { XHRRequestCanceler } from "../../Libs/xhr/XHRRequestCanceler";
import {
  WorkerNewPasswordResponse,
  WorkersDetailsResponse,
  WorkersListSummaryResponse,
} from "../Models/Workers/Workers";
import { BaseDataService } from "./Base/BaseDataService";

const WorkersEndpoints = {
  WORKERS: "/api/v1/admins/users",
  WORKERS_DETAILS: (workerId: string) => `/api/v1/admins/users/${workerId}`,
  WORKER_UPDATE: (workerId: string) => `/api/v1/admins/users/${workerId}`,
  WORKER_NEW_PASSWORD: (workerId: string) => `/api/v1/admins/users/${workerId}/code`,
};

export interface IWorkersDataService {
  getWorkers: (cts?: XHRRequestCanceler) => Promise<WorkersListSummaryResponse>;

  updateWorker: (workerId: string, enabled: boolean, cts?: XHRRequestCanceler) => Promise<WorkersDetailsResponse>;

  getWorkerNewPassword: (workerId: string) => Promise<WorkerNewPasswordResponse>;

  getWorkerDetails: (workerId: string, cts?: XHRRequestCanceler) => Promise<WorkersDetailsResponse>;
}
class WorkersDataService extends BaseDataService implements IWorkersDataService {
  getWorkers = (cts?: XHRRequestCanceler): Promise<WorkersListSummaryResponse> => {
    return this.get<WorkersListSummaryResponse>(WorkersEndpoints.WORKERS, cts);
  };

  updateWorker = (workerId: string, enabled: boolean, cts?: XHRRequestCanceler): Promise<WorkersDetailsResponse> => {
    const body = {
      enabled: enabled,
    };
    if (enabled) {
      return this.patch<WorkersDetailsResponse>(WorkersEndpoints.WORKER_UPDATE(workerId), body, cts);
    } else {
      return this.delete<WorkersDetailsResponse>(WorkersEndpoints.WORKER_UPDATE(workerId), cts);
    }
  };

  getWorkerNewPassword = async (workerId: string): Promise<WorkerNewPasswordResponse> => {
    return this.post<WorkerNewPasswordResponse>(WorkersEndpoints.WORKER_NEW_PASSWORD(workerId), {});
  };

  getWorkerDetails = (workerId: string, cts?: XHRRequestCanceler): Promise<WorkersDetailsResponse> => {
    return this.get<WorkersDetailsResponse>(WorkersEndpoints.WORKERS_DETAILS(workerId), cts);
  };
}

const WorkersDataServiceName = "WorkersDataService";
export { WorkersDataService, WorkersDataServiceName };
